import $ from 'jquery';

function initWorkoutParticipant(){
	var activityArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	var activityArrayAll = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	
	if ( !JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId ) 
		{
			for ( let i = 0; i < activityArray.length; i++ )
				{
					if ( activityArray[i]['attribute'][0]['attrValue'] == 'Pause' || activityArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
						{
							activityArray.splice(i, 1);
							i--;
						}
				}
		}
	
	var nextActivity = {};
	var nextIndex = 0;
	var nextIndexNum = 0;
	var currentUserData = JSON.parse(localStorage.getItem("userData"));
	var act_type = '';
	var script_name = '';
	var sep = '~@$';
	
	function setNextActivity(mod){
		var currentIndex = nextIndex;
		
		var currentIndexPlus = 0;
		var currentIndex = 0;
		if ( window['currentIndex'] == -1 )
			{
				currentIndexPlus = 0;
				currentIndex = 0;
			}
		else if ( window['currentIndex'] == 0 )
			{
				currentIndexPlus = 1;
			}			
		else 
			{
				currentIndex = window['currentIndex'];
				currentIndexPlus = parseInt(window['currentIndex']) + 1;
			}	
			
		nextActivity = activityArray[nextIndexNum];
		
		if ( nextIndexNum )
			{
				$('#currentIndex').text(nextIndexNum);
			}
		else 
			{
				$('#currentIndex').text(0);
			}			
		
		if ( nextActivity )
			{	
				var act_name = nextActivity.name;
				if ( nextActivity.attribute && nextActivity.attribute[12] && nextActivity.attribute[12].attrValue ) { act_name = nextActivity.attribute[12].attrValue; }
				
				$('#workoutName').text(act_name);
				$('#nextActName').text(act_name);
			}
		else 
			{
				let currentAct = activityArray[window['currentIndex']];
				if ( currentAct )
					{
						var act_name = currentAct.name;
						if ( currentAct.attribute && currentAct.attribute[12] && currentAct.attribute[12].attrValue ) { act_name = currentAct.attribute[12].attrValue; }
						
						$('#workoutName').text(act_name);
						$('#nextActName').text(act_name);
					}
			}			
		 
		
	
		var activityType = '';
		var durationInSec = 0;
		if ( nextActivity )
			{
				for ( var i = 0; i < nextActivity.attribute.length; i++ )
					{
						if ( nextActivity.attribute[i].attrLabel == 'Duration' && nextActivity.attribute[i].attrValue == 'Reps' )
							{
								activityType = nextActivity.attribute[9].attrValue + '/' + nextActivity.attribute[3].attrValue + ' reps';
								durationInSec = nextActivity.attribute[3].attrValue * nextActivity.attribute[9].attrValue;
							}
							
						if ( nextActivity.attribute[i].attrLabel == 'Duration' && nextActivity.attribute[i].attrValue == 'Time' )
							{
								durationInSec = nextActivity.attribute[2].attrValue;
								activityType = nextActivity.attribute[2].attrValue + ' seconds';
							}
					}
				console.log('setNextActivity activityType', activityType);
				$('#workoutType').text(activityType);
			}
		
	}
	
	function setIndexWithoutPause(index){
		var indexWithoutPause = index;
		
		console.log('indexWithoutPause before', indexWithoutPause);
		
		if ( !currentUserData.sessionData.ondemandId )
			{
				for ( var i = 0; i < index; i++ )
					{
						if ( activityArrayAll[i] && ( activityArrayAll[i]['attribute'][0]['attrValue'] == 'Pause' || activityArrayAll[i]['attribute'][0]['attrValue'] == 'Pause Virtual' ) )
							{
								indexWithoutPause--;
								console.log('indexWithoutPause--', indexWithoutPause);
							}
					}
			}
		console.log('indexWithoutPause after', indexWithoutPause);
			
		return indexWithoutPause;
	}
	
	setTimeout(function(){ setNextActivity(); }, 1);
	
	window.setNextActivityParticipants = (mod) => {
		if ( mod && mod != 'start' )
			{
				nextIndex++;
				nextIndexNum++;
				mod = setIndexWithoutPause(mod);
				if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 ) { nextIndex = mod; nextIndexNum = mod;  }
			}
		else if ( mod && mod == 'start' )
			{
				if ( nextIndexNum == 0 )
					{
						nextIndexNum = 1;
					}
				
			}			
		setNextActivity();
	}
	
	
	window.setNextIndexNum = (mod) =>{
		let calcIndex = setIndexWithoutPause(mod);
		nextIndexNum = calcIndex;
		setNextActivity();
	};
	
	window.setIndexNumAfterSync=(mod)=>{
		if ( mod < activityArray.length )
			{
				//nextIndex = setIndexWithoutPause();
				setNextActivity(mod);
			}
		
	}
	
	window.stopFooterActivity = (isFromSync) => {
		if ( activityArray.length == 0 ) { return false; }
		
		nextIndex = 0;
		nextIndexNum = 0;
		window['globalCurrentIndex'] = nextIndex;
		window['allIndexGlobal'] = nextIndex;
		setNextActivity();
		
		if ( isFromSync )
			{
				$('#currentIndex').text(activityArray.length); 
			}
	}
	
	window.setNextActivitySync = (index) => {
		setTimeout(function() {
			//window.setNextActivityVirtual(index);
			//nextIndex = index+1;
			setNextActivity(true);
		}, 500);
	}
	
	window.setNextActivityVirtual = (index, prevAct) => {
		console.log(prevAct, 'setNextActivityVirtual called');
		
		if ( !index ) { index = nextIndex-1 > -1 ? nextIndex-1 : 0; }
		
		window['allIndexGlobal'] = index;
		
		index = setIndexWithoutPause(index);
		
		act_type = activityArray[index]['attribute'][0]['attrValue'];
		script_name = activityArray[index]['name'];
		window['globalCurrentIndex'] = index;
		
		if ( (!window['userWhiteboard'][currentUserData.id] || (window['userWhiteboard'][currentUserData.id] && !window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured )) && window['hasConeScript'] )
			{
				if ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' ) { window['firstActSetup'+currentUserData.id] = true; }
				//window['readyGo'] = true;
		console.log('setNextActivityVirtual 1');
				if ( window['streamSwapped'] && !window['deviceNotSupported'] ) { console.log('setNextActivityVirtual 2', window.startRoomSetup); window.startRoomSetup(); console.log('setNextActivityVirtual 3');}
				if ( !window['streamSwapped'] && !window['deviceNotSupported'] ) { window.swapStreamVirtual(false); }
			}
		if ( ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) && (window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured) && window['hasConeScript'] )
			{
				console.log('setNextActivityVirtual 1');
				
				if ( window['deviceNotSupported'] ) 
					{ 
						$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none'); 
					}
					
				if ( window.detectionDisabled ) 
					{ 
						$('.virtualDisabledMsg').removeClass('d-none'); 
					}
				
				if ( window['deviceNotSupported'+currentUserData.id] )
					{
						$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none');
					}
				
				//window['readyGo'] = true;
				window.$('#repcounter').html(0);
				console.log('setNextActivityVirtual 2');
				if ( !window['streamSwapped'] && !window['deviceNotSupported'] ) {
				console.log('setNextActivityVirtual 3'); window.swapStreamVirtual(false);
				console.log('setNextActivityVirtual 4'); }
				console.log('setNextActivityVirtual 5');
			}
		if ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' && window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured )
			{
				if ( window['streamSwapped'] && !window['deviceNotSupported'] ) { window.swapStreamVirtual(true); }
			}
		if ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' )
			{
				window.$('#virtualPunchHold').addClass("d-none");
				window.$('#virtualPunchMinuteHold').addClass("d-none");
			}
				console.log('setNextActivityVirtual 6');
		
		if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) { return script_name; }
		else { return false; }
	}
}

export default initWorkoutParticipant;